import DapDSCommandGroup from './command-group.component'

export * from './command-group.component'
export default DapDSCommandGroup

DapDSCommandGroup.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-command-group': DapDSCommandGroup
  }
}
